import { gql } from '@apollo/client';
import { CODE_FRAGMENT, IDENTIFIER_FRAGMENT } from '../../shared/fragments';

export const FETCH_ALL_CAREPLANS_QUERY = gql`
  query fetchAllCarePlans(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllCarePlans(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      carePlanList
      count
    }
  }
`;
export const FETCH_CAREPLANS_BY_ID_QUERY = gql`
  query fetchCarePlanById($carePlanId: String) {
    fetchCarePlanById(carePlanId: $carePlanId) {
      id
      status
      title
      description
      intent
      category {
        ...code
      }
      period {
        start
        end
      }
      created
      goal {
        reference
        display
        identifier {
          ...identifier
        }
      }
      careTeam {
        reference
        display
        identifier {
          ...identifier
        }
      }
      author {
        reference
        display
        identifier {
          ...identifier
        }
      }
      activity {
        performedActivity {
          ...code
        }
        progress {
          text
        }
        detail {
          code {
            ...code
          }
        }
      }
      contributor {
        reference
        display
        identifier {
          ...identifier
        }
      }
      addresses {
        reference
        display
        identifier {
          ...identifier
        }
      }
      identifier {
        ...identifier
      }
    }
  }

  ${CODE_FRAGMENT}
  ${IDENTIFIER_FRAGMENT}
`;
